import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from '../../../actions'
import Merchandise from './Merchandise'
import axios from 'axios'
import { Container, Button, Icon, Form, FormGroup, FormField, Input, Divider, Message, Select } from 'semantic-ui-react'

const ResellerGame = ({ game, backClicked, markup }) => {
    const [userID, setUserID] = useState('')
    const [serverID, setServerID] = useState('')
    const [userName, setUserName] = useState('')
    const [characterName, setCharacterName] = useState('')
    const [userIsValid, setUserIsValid] = useState(false)
    const [isLoadingVerify, setIsLoadingVerify] = useState(false)
    const [showInvalidUserMessage, setShowInvalidUserMessage] = useState(false)
    const [showOutOfStockMessage, setShowOutOfStockMessage] = useState(false)
    const [showPurchaseSuccessMessage, setShowPurchaseSuccessMessage] = useState(false)

    const dispatch = useDispatch()
    const user = useSelector(state => state.userReseller)

    const getResellerMarkup = () => {
        return markup[game.supplierName]
    }
    const getPrice = (cost, discounted, discountRate) => {
        const adjustedMarkup = (discounted && !user.disableDiscounts) ? Number(getResellerMarkup()) - Number(discountRate) : Number(getResellerMarkup())
        return Number(cost) + (adjustedMarkup / 100 * Number(cost))
    }
    const getServerOptions = () => {
        return Object.entries(game.servers).map(([key, value]) => ({ key: key, text: key, value: value }))
    } 
    console.log(game)
    const handleChangeField = e => {
        const { name, value } = e.target
        if (name === 'userID') setUserID(value)
        if (name === 'serverID') setServerID(value)
        if (name === 'characterName') setCharacterName(value)
    }
    const handleChangeServerDropDown = (e, data) => {
        setServerID(data.value)
    }
    const handleVerifyButtonClicked = async () => {
        if (userID === '' || (game.requiresServerID && serverID === '')) return
        dispatch(actions.fetchGames('resellers'))
        setIsLoadingVerify(true)
        setShowPurchaseSuccessMessage(false)
        var dict = {}
        var url = ''
        if (game.supplier === 'elephant') {
            dict = { game: game.supplierName, userid: userID, serverid: serverID, reseller: user.name }
            url = process.env.NODE_ENV === 'development' ? '/api/proxy/resellers/verify_id' : '/api/resellers/verify_id'
        } else if (game.supplier === 'monkey') {
            dict = { game: game.supplierGameID, userid: userID, serverid: serverID, reseller: user.name, gameName: game.name }
            url = '/api/product_validate'
        } 
        await axios.post(url, dict).then(res => {
            if (game.supplier === 'elephant') {
                const { valid, name, error } = res.data
                if (error) {
                    setShowOutOfStockMessage(true)
                }
                if (valid === 'valid') {
                    setUserIsValid(true)
                    setUserName(name)
                    setShowInvalidUserMessage(false)
                    setIsLoadingVerify(false)
                } else {
                    setUserIsValid(false)
                    setShowInvalidUserMessage(true)
                    setIsLoadingVerify(false)
                }
            } else if (game.supplier === 'monkey') {
                const { status, username } = res.data
                if (status === 'true') {
                    setUserIsValid(true)
                    setUserName(username)
                    setShowInvalidUserMessage(false)
                    setIsLoadingVerify(false)
                } else {
                    setUserIsValid(false)
                    setShowInvalidUserMessage(true)
                    setIsLoadingVerify(false)
                }
            }
        }).catch(err => {
            console.log(`verify ID failed with error: ${err}`)
            alert(`Failed to verify ID, please try again. Error: ${err}`)
            setIsLoadingVerify(false)
        })
    }

    const handlePurchaseItem = async item => {
        setIsLoadingVerify(true)
        var dict = {}
        var url = ''
        if (game.supplier === 'monkey')  {
            dict = { reseller: { name: user.name, id: user._id }, game: game.name, productID: item.id, userid: userID, serverid: serverID, denom: item.nameSupplier, userName, itemName: item.nameReseller, 
                        amount: roundUp2DP(getPrice(item.cost, item.isDiscountedReseller, item.discountRateReseller)), cost: item.cost }
            url = '/api/create_order'
        } else if (game.supplier === 'elephant') {
            dict = { reseller: { name: user.name, id: user._id }, game: game.name, supplierGameName: game.supplierName, userid: userID, serverid: serverID, denom: item.nameSupplier, userName, itemName: item.nameReseller, 
                        amount: roundUp2DP(getPrice(item.cost, item.isDiscountedReseller, item.discountRateReseller)), cost: item.cost }
            url = process.env.NODE_ENV === 'development' ? '/api/proxy/place_order' : '/api/reseller/place_order'
        } 
        await axios.post(url, dict).then(res => {
            dispatch(actions.getCurrentUserReseller())
            setUserID('')
            setServerID('')
            setUserIsValid(false)
            setIsLoadingVerify(false)
            setShowPurchaseSuccessMessage(true)
        }).catch(err => {
            if (err.response) {
                const statusCode = err.response.status
                console.log(`Verify ID failed with status: ${statusCode}, error: ${err.response.data}`)
                if (statusCode === 403) {
                    alert('Insufficient balance in your account, please check.')
                } else {
                    alert(`Failed to place order, please try again. Status: ${statusCode}, Error: ${err.response.data}`)
                }
            } else {
                console.log(`Verify ID failed with error: ${err.message}`)
                alert(`Failed to place order, please try again. Error: ${err.message}`)
            }
            setIsLoadingVerify(false)
        })
    }

    const renderServerField = () => {
        if (!!game.servers) {
            return <FormField control={Select} label='Server' name='serverID' value={serverID} options={getServerOptions()} placeholder='Select Server...' onChange={handleChangeServerDropDown} className="dark-theme-input" inverted/>
        } else {
            return <FormField required control={Input} label='Server ID' name='serverID' value={serverID} placeholder='Server ID' onChange={handleChangeField} className="dark-theme-input"/>
        }
    }

    return (
        <Container inverted style={{ background: '#1b1c1d' }}>
            <h2 style={{ marginTop: 30, color: 'white' }}>{game.name}</h2>
            <Form inverted style={{ marginTop: 25 }}>
                <FormGroup widths='equal'>
                    <FormField required control={Input} label='User ID' name='userID' value={userID} placeholder='User ID' onChange={handleChangeField} className="dark-theme-input"/>
                    {game.requiresServerID ? renderServerField() : null}
                    {game.requiresCharacterName ? <FormField required control={Input} label='Character Name' name='characterName' value={characterName} placeholder='Character Name' onChange={handleChangeField} className="dark-theme-input"/> : null}
                </FormGroup>
                {userIsValid ? <h4 style={{ color: 'white' }}>{userName} ✅</h4> : null}
                <Button inverted loading={isLoadingVerify} style={{ marginTop: 15 }} color='blue' onClick={handleVerifyButtonClicked}><Icon name='gem'/>Verify</Button>
            </Form>
            {showOutOfStockMessage || game.isOutOfStock ? (
                <Message inverted style={{ marginTop: 30, marginBottom: 30 }} negative header={'Items for ' + game.name + ' are currently Out of Stock / Under Maintenance.'} content='Please try again later.'/>
            ) : null}
            {showInvalidUserMessage ? (
                <Message inverted style={{ marginTop: 20 }} negative header='Invalid user' content='Please check and try again.'/>
            ) : null}
            {showPurchaseSuccessMessage ? (
                <Message inverted style={{ marginTop: 20 }} success header={'Placed order successfully for User: ' + userName} content='You may track the order status in the Orders page.'/>
            ) : null}
            {userIsValid && !showOutOfStockMessage && !game.isOutOfStock ? (
                <div>
                    <Divider inverted style={{ marginTop: 30 }}/>
                    <Merchandise isReseller disableDiscounts={user.disableDiscounts} userName={userName} savedDict={{ gameItems: game.gameItems }} markup={getResellerMarkup()} placeOrder={handlePurchaseItem}/>
                </div>
            ) : null}
            <br/><br/><br/><br/><br/><br/>
            <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, background: '#2a2b2c', borderTop: '2px solid #444', padding: '10px', zIndex: 100 }}>
                <Container inverted>
                    <Button inverted style={{ marginTop: 10, marginRight: 15, marginBottom: 15 }} color='blue' onClick={backClicked}><Icon name='reply' />Back</Button>
                </Container>
            </div>
        </Container>
    )
}

const roundUp2DP = num => {
    return Math.ceil(num * 100) / 100
}

export default ResellerGame